import { render, staticRenderFns } from "./Pane.vue?vue&type=template&id=661b06c8&scoped=true&"
import script from "./Pane.vue?vue&type=script&lang=ts&"
export * from "./Pane.vue?vue&type=script&lang=ts&"
import style0 from "./Pane.vue?vue&type=style&index=0&id=661b06c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661b06c8",
  null
  
)

component.options.__file = "Pane.vue"
export default component.exports